import { CalculatedLine, Component } from '@paragon/contract-library';
import { calculateLine } from '@paragon/relative-geometry';

export function groupCoincidentReferenceLines(lines: CalculatedLine[], component: Component): CalculatedLine[][] {
  const groups: CalculatedLine[][] = [];

  for (const line of lines) {
    const calculatedLine = calculateLine(line, component);
    if (calculatedLine === null) continue;

    let addedToExistingGroup = false;

    for (const group of groups) {
      const exemplar = calculateLine(group[0], component)!;

      if (calculatedLine.equals(exemplar)) {
        group.push(line);
        addedToExistingGroup = true;

        break;
      }
    }

    if (!addedToExistingGroup) {
      groups.push([line]);
    }
  }

  return groups;
}
